export default __webpack_public_path__ + "static/media/nicotina-bg.039addf7.jpg";